function add_prefix_x_data(el) {
  const props = JSON.parse(el.dataset.props);
  return {
      screen: 1,
      rss_feed: "",
      genre: [],
      content: "",
      show_title: "",
      show_author: "",
      show_description: "",
      hosting_platform: "",
      added_prefix_confirmation: false,
      correct_show_confirmation: false,
      adding_new_show: false,
      verifying_ownership: false,
      validating_rss_feed: false,
      cover_art: "",
      email_code: "",
      email: "",
      showSidebar: false,
      user_inputted_show_name: "",
      timeout: null,
      platform: "",
      prefix_link: props.prefixLink,
      prefix_steps: props.prefixInstructions,
      cant_find_show_modal_visible: false,
      resend_verification_email_visible: false,
      cant_access_email_visible: false,
      cant_access_email_screen: 1,
      open: false,
      show_array: [],
      email_sent_to: "",
      verification_token: "",
      prefix_url: "",
      showMessage: false,
      showMessageVar: {
          variation1: false,
          variation2: false,
          variation3: false,
          variation4: false
      },
      rssFeedValidationError: false,
      rssFeedValidationErrorMessage: "",
      isInitializing: true,
      async populate_show_array(term) {
          const that = this
          if (term === "") {
              that.show_array = []
              that.$refs.panel.innerHTML = ""
              return
          }
          const response = await fetch(`${props.searchUrl}?term=${encodeURIComponent(term)}`);
          const shows_data = await response.json();
          const shows = shows_data.data.feeds
          that.show_array = []
          if (shows.length > 0) {
              shows.forEach(show => {
                  that.show_array.push({
                      show_author: show.author,
                      show_name: show.title,
                      cover_art: show.artwork,
                      rss_feed: show.url,
                      genre: show.categories ? Object.values(show.categories).join(", ") : [],
                      content: show.explicit ? "Explicit" : "Clean"
                  })
              })
          }
          that.create_dropdown()
      },
      create_dropdown() {
          this.$refs.panel.innerHTML = ""
          if (this.show_array.length === 0) {
              this.$refs.panel.insertAdjacentHTML("beforeend",
                  `<div class="flex space-x-4 items-center p-4 cursor-pointer rounded-md hover:bg-gray-50" @click="open = false">
                      <span>No Show Found</span>
                    </div>`)
          } else {
              this.show_array.forEach((show, idx) => {
                  this.$refs.panel.insertAdjacentHTML("beforeend",
                      `<div class="flex space-x-4 items-center p-4 cursor-pointer rounded-md hover:bg-gray-50" @click="selectShow(${idx}); open = false">
                      <img width="50" height="50" src="${show.cover_art}">
                      <span>${show.show_name}</span>
                    </div>`)
              })
          }
          this.open = true
      },
      selectShow(show_index) {
          const show = this.show_array[show_index]

          // Prevent watcher from clearing data when selecting a show
          this.isInitializing = true;
          
          this.rss_feed = show.rss_feed
          this.show_title = show.show_name
          this.show_author = show.show_author
          this.cover_art = show.cover_art
          this.genre = show.genre
          this.content = show.content
          this.hosting_platform = this.get_base_domain()
          
          // Re-enable watcher
          this.$nextTick(() => {
              this.isInitializing = false;
          });
      },
      toggle() {
          if (this.open) {
              return this.close()
          }
          this.$refs.button.focus()

          this.open = true
      },
      close(focusAfter) {
          if (!this.open) return

          this.open = false

          focusAfter && focusAfter.focus()
      },
      async init() {
          const that = this
          that.validating_rss_feed = false
          new TomSelect("#hosting_providers", {maxItems: 1});

          const response = await fetch(props.getDataUrl, {
              method: "GET",
              headers: {
                  "Content-Type": "application/json"
              }
          })
          const result = await response.json()
          const data = result.podcast_data

          console.log("Saved data:", data)

          if (data) {
              that.prefix_url = data.prefix_code
              that.show_author = data.author
              that.show_title = data.title
              that.rss_feed = data.new_feed_url
              that.cover_art = data.cover_art_url
              data.explicit ? that.content = "Explicit" : that.content = "Clean"
              that.genre = data.main_category
              that.hosting_platform = that.get_base_domain()
              that.screen = 3
          }
          this.$watch('rss_feed', value => {
              // Don't clear data during initialization (when loading saved data)
              if (this.isInitializing) {
                  return;
              }
              
              this.showSidebar = false;
              this.rssFeedValidationError = false;
              this.rssFeedValidationErrorMessage = "";
              this.show_title = "";
              this.show_author = "";
              this.cover_art = "";
              this.genre = "";
              this.content = "";
              this.hosting_platform = "";
              this.show_description = "";
              this.email = "";
          });
          
          // Mark initialization as complete
          this.isInitializing = false;
      },
      previous_screen() {
          this.screen = 1
      },
      async validate_rss_feed() {
          if (!this.added_prefix_confirmation) {
              return
          }

          // Temp fix: prevent double-clicks by checking flag inside function
          if (this.validating_rss_feed) {
              return
          }

          this.validating_rss_feed = true

          try {
              const that = this
              const response = await fetch(props.validateShowUrl, {
                  method: "POST",
                  headers: {
                      "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                      authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                      prefix_code: that.prefix_url,
                      author: that.show_author,
                      title: that.show_title,
                      new_feed_url: that.rss_feed,
                      cover_art_url: that.cover_art,
                      explicit: that.content === "Explicit",
                      main_category: that.genre.split(",")[0]
                  })
              })

              const result = await response.json()

              if (!response.ok) {
                  const errorMessage = result.message || result.errors?.join(', ') || 'Failed to validate RSS feed'
                  console.error("Server error:", errorMessage)
                  alert(`Failed to validate RSS feed: ${errorMessage}`)
                  return
              }

              const data = result.data.message

              console.log(data)
              this.screen = 4
          } catch (e) {
              console.error("Validation error:", e)
              alert("Failed to validate RSS feed. Please try again.")
          } finally {
              this.validating_rss_feed = false
          }
      },
      go_to_dashboard() {
          // location.reload();
          location.href = '/'
      },
      copy_prefix(link, variation = 1) {
          if (navigator.clipboard && window.isSecureContext) {
              navigator.clipboard.writeText(link);
          } else {
              const textArea = Object.assign(document.createElement("textarea"), {
                  value: link,
                  style: {position: "absolute", left: "-9999px"}
              });

              document.body.appendChild(textArea);
              textArea.select();

              try {
                  document.execCommand("copy");
              } catch (error) {
                  console.error("Copy failed:", error);
              } finally {
                  document.body.removeChild(textArea);
              }
          }

          if (variation === 2) {
              this.showMessageVar.variation2 = true;
              setTimeout(() => {
                  this.showMessageVar.variation2 = false;
              }, 1000);
          } else if (variation === 3) {
              this.showMessageVar.variation3 = true;
              setTimeout(() => {
                  this.showMessageVar.variation3 = false;
              }, 1000);
          } else if (variation === 4) {
              this.showMessageVar.variation4 = true;
              setTimeout(() => {
                  this.showMessageVar.variation4 = false;
              }, 1000);
          } else {
              this.showMessageVar.variation1 = true;
              setTimeout(() => {
                  this.showMessageVar.variation1 = false;
              }, 1000);
          }
      },
      get_base_domain() {
          const that = this
          const url = new URL(that.rss_feed)
          const full_url = url.host
          const url_arr = full_url.split(".")

          return this.capitalizeFirstLetter(url_arr[url_arr.length - 2])
      },
      capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
      },
      async add_my_show() {
          const that = this
          that.adding_new_show = true
          const response = await fetch(props.addShowUrl, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                  authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                  feed_url: that.rss_feed
              })
          })
          const result = await response.json()
          const data = result.data.message
          that.adding_new_show = false

          console.log(data)

          if (data.feed_exists === true) {
              // Handle feed exists
              alert("Feed exists")
              return
          }

          if (data.verification_token !== null) {
              that.verification_token = data.verification_token
              that.email_sent_to = data.email_sent_to
          }
          that.screen = 2
      },
      async verify_ownership() {
          const that = this
          that.verifying_ownership = true
          const response = await fetch(props.verifyOwnershipUrl, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                  authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                  feed_url: that.rss_feed,
                  verification_token: that.verification_token,
                  email_code: that.email_code
              })
          })
          const result = await response.json()
          const data = result.data.message
          that.verifying_ownership = false
          console.log(data)

          if (data.invalid_email_code === true) {
              alert("Invalid Email Code")
              return
          }
          // Instead of localStorage, make another call to the backend and save all the data needed on the next
          // screen
          that.prefix_url = data.prefix
          await that.save_podcast_data()
          that.screen = 3
      },
      async save_podcast_data() {
          const that = this
          const response = await fetch(props.saveDataUrl, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                  authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                  prefix_code: that.prefix_url,
                  author: that.show_author,
                  title: that.show_title,
                  new_feed_url: that.rss_feed,
                  cover_art_url: that.cover_art,
                  explicit: that.content === "Explicit",
                  main_category: that.genre.split(",")[0]
              })
          })
          const result = await response.json()
          console.log(result)

          // todo: Handle data
          if (result.success) {
              // Data has been succesfully saved
              console.log("Saved")
          } else {
              alert("Your data has not been saved.")
          }
      },
      async resend_verification_email() {
          const that = this
          const response = await fetch(props.addShowUrl, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                  authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                  feed_url: that.rss_feed
              })
          })
          const result = await response.json()
          const data = result.data.message

          console.log(data)

          if (data.feed_exists === true) {
              // Handle feed exists
              alert("Feed exists. Please restart the process with a different show.")
              return
          }

          if (data.verification_token !== null) {
              that.verification_token = data.verification_token
              that.email_sent_to = data.email_sent_to
              that.resend_verification_email_visible = false
          } else {
              //    This shouldn't happen
              alert("Couldn't resend verification email")
          }
      },
      async cant_access_email() {
          const that = this

          const response = await fetch(props.addShowUrl, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                  authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                  feed_url: that.rss_feed
              })
          })
          const result = await response.json()
          const data = result.data.message

          console.log(data)

          if (data.feed_exists === true) {
              // Handle feed exists
              alert("Feed exists. Please restart the process with a different show.")
              return
          }

          if (data.verification_token !== null) {
              that.verification_token = data.verification_token
              that.email_sent_to = data.email_sent_to

              that.cant_access_email_visible = false
              that.cant_access_email_screen = 1
          } else {
              //    This shouldn't happen
              alert("Couldn't resend verification email")
          }
      },
    async validateRssFeed() {
        if (!this.rss_feed) return;
        
        // Frontend validation: Check if URL starts with http:// or https://
        const trimmedUrl = this.rss_feed.trim();
        if (!trimmedUrl.startsWith('http://') && !trimmedUrl.startsWith('https://')) {
            this.rssFeedValidationError = true;
            this.rssFeedValidationErrorMessage = "Please include http:// or https:// at the beginning of your RSS feed URL.";
            this.showSidebar = false;
            return;
        }
        
        try {
            const response = await fetch(props.retrieveRssUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({ feed_url: trimmedUrl })
            });
            const result = await response.json();
            this.rssFeedValidationError = result.valid === false;
            if (result.valid && result.data) {
                this.rssFeedValidationErrorMessage = "";
                this.show_title = result.data.show_title || "";
                this.show_author = result.data.show_author || "";
                this.cover_art = result.data.cover_art || "";
                this.genre = result.data.genre || "";
                this.content = result.data.explicit === 'yes' ? 'Explicit' : 'Clean';
                this.hosting_platform = result.data.hosting_platform || this.get_base_domain();
                this.show_description = result.data.show_description || "";
                this.email = result.data.email || "";
                this.showSidebar = true;
            } else {
                // Log technical details to console for debugging
                console.error("RSS Feed Validation Failed:", result.error);
                this.rssFeedValidationErrorMessage = result.error || "Unable to validate RSS feed. Please verify the URL and try again.";
                this.showSidebar = false;
            }
        } catch (e) {
            // Log technical error to console for debugging
            console.error("RSS Feed Validation Error:", e);
            this.rssFeedValidationError = true;
            this.rssFeedValidationErrorMessage = "Unable to validate RSS feed. Please verify the URL and try again.";
            this.showSidebar = false;
        }
    },
  };
}

window.add_prefix_x_data = add_prefix_x_data;
